import React from 'react';
import { Field, FieldProps } from 'formik';

import { Checkbox } from '../inputs';
import { Props as CheckboxProps } from '../inputs/Checkbox';
import { formatMessage } from '@/utils/i18n';

interface ExtendedCheckboxProps extends CheckboxProps {
  'aria-label'?: string;
}

const CustomField = ({ field, form, ...props }: FieldProps<ExtendedCheckboxProps>) => {
  const propsWithAria = props as ExtendedCheckboxProps;
  const ariaLabel = propsWithAria['aria-label'] || propsWithAria.label || formatMessage('Common.Accessibility.CheckboxFor', { fieldName: field.name });

  const onChangeHandler = (checked: boolean) => {
    form.setFieldValue(field.name, checked);
  };

  return <Checkbox selected={field.value} {...field} {...props} aria-label={ariaLabel} onChange={onChangeHandler} />;
};

const FormInput = (props: Partial<ExtendedCheckboxProps>) => <Field {...props} component={CustomField} />;

export default FormInput;
